import React, { Fragment, SyntheticEvent } from "react";

export type StatusItem = {
  number: number;
  label: string;
  onClick?: () => void;
};

export type StatusProps = {
  current: number;
  statusSteps: StatusItem[];
  translate: (code: string) => string;
};

function cancel(call?: () => void) {
  return (e: SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
    call?.();
  };
}

const Status = ({ current, statusSteps, translate }: StatusProps) => (
  <div id="stepper" className="d-flex justify-content-between align-items-center mb-7">
    {statusSteps.map(({ number, label, onClick }) => (
      <Fragment key={number}>
        <div
          onClick={current > number ? cancel(onClick) : undefined}
          className={`status-step ${current < number ? "inactive" : ""}`}>
          <span>{number}</span>
          <div className={`d-none d-lg-block ${current === number ? "current" : current > number ? "past" : ""}`} />
        </div>
        {number < statusSteps[statusSteps.length - 1].number && (
          <div className={`status-line ${current - 1 < number ? "inactive" : ""}`} />
        )}
      </Fragment>
    ))}
  </div>
);

export default Status;
